// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time[data-v-7b20fc0a]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:30px;font-weight:700;color:#4caf50}", ""]);
// Exports
module.exports = exports;
